import React from 'react';

import HeaderNavComponent from '../header/HeaderNavComponent';
import FooterComponent from '../footer/FooterComponent';
import { BreadcrumbComponent } from '../breadcrumb/BreadcrumbComponent';

export const CategoryDirectoryTemplate = props => {
    return (
        <div className="template template-category-directory flex-container-v">
            <HeaderNavComponent />
            {React.cloneElement(props.children, {
                Breadcrumb: BreadcrumbComponent
            })}
            <FooterComponent />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/template/CategoryDirectoryTemplate.js